<select [(ngModel)]="SelectedOption" (change)="updateSelected()" class="text-box max-w-xl">
  @for (a of currentQuestion.QuestionAnswers; track a) {
    <option [ngValue]="a" [disabled]="a.QuestionAnswerID == -1">
      {{a.AnswerText}}
    </option>
  }
</select>